import { IApplicationState } from '../../types/redux';

export const selectAppliedFilters = (state: IApplicationState) => {
  return state.filters.appliedFilters;
};
